import React from 'react'
import { motion } from 'framer-motion'
import C1 from '../../Assets/images/co1.svg'
import C2 from '../../Assets/images/co2.svg'
import C3 from '../../Assets/images/co3.svg'
import C4 from '../../Assets/images/co4.svg'
import CoreComponent from './CoreComponent'
import FadeInSection from '../FadeInSection'

const containerVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      staggerChildren: 0.2,
      ease: "easeOut",
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
}

function Core() {
  return (
      <motion.div
        className="px-6 sm:px-24 bg-text-gray py-16"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
      viewport={{ once: false, amount: 0.2 }} 
      >
        <motion.h1
          className="text-[24px] text-text-color1 mb-5 sm:text-[44px]"
          variants={itemVariants}
        >
          Our core values
        </motion.h1>

        <motion.p
          className="sm:w-[80%] text-text-color1 text-[14px] sm:text-[20px] font-medium"
          variants={itemVariants}
        >
          At HalalWealth, our values shape our culture, define who we are, and
          guide everything we do. They form the foundation of our identity and
          serve as the compass for how we engage with all our stakeholders,
          including customers, regulators, investors, partners, and the
          communities we serve.
        </motion.p>

        <motion.div
          className="grid sm:grid-cols-2 gap-5 mt-7"
          variants={containerVariants}
        >
          <motion.div variants={itemVariants}>
            <CoreComponent
              image={C1}
              color={"bg-[#ECF9F3]"}
              header={"Simplicity & Empathy"}
              con={
                "We create simple but powerful experiences because greatness is simple. We see with the eyes of our customers, listen with their ears and feel with their hearts."
              }
            />
          </motion.div>

          <motion.div variants={itemVariants}>
            <CoreComponent
              image={C2}
              color={"bg-[#F5F1FE]"}
              header={"We’re building together"}
              con={
                "We create simple but powerful experiences because greatness is simple. We see with the eyes of our customers, listen with their ears and feel with their hearts."
              }
            />
          </motion.div>

          <motion.div variants={itemVariants}>
            <CoreComponent
              image={C3}
              color={"bg-[#F5F1FE]"}
              header={"Our way with words"}
              con={
                "How we communicate changes how people feel about us, so we’d better make sure our words reflect what we stand for. Our tone of voice guidelines exist to do just that."
              }
            />
          </motion.div>

          <motion.div variants={itemVariants}>
            <CoreComponent
              image={C4}
              color={"bg-[#ECF9F3]"}
              header={"Personal Growth & Development"}
              con={
                "Our growth as a company is a product of the growth of our individual team members. Grow daily. It compounds. Do your best work, daily."
              }
            />
          </motion.div>
        </motion.div>
      </motion.div>
  )
}

export default Core
